import React, { useEffect } from 'react';
import {
    Create,
    SelectInput,
    SimpleForm,
    TextInput,
    ReferenceInput,
    AutocompleteInput,
    FormDataConsumer,
    useDataProvider,
} from 'react-admin';
import { useForm, useFormState } from 'react-final-form';
import PlaceAutoComplete from '../components/PlaceAutoComplete';
import useIsAdmin from '../hooks/useIsAdmin';

const AddressCountryPrefill = () => {
    const form = useForm();
    const { values } = useFormState();
    const dataProvider = useDataProvider();
    const isAdmin = useIsAdmin();

    useEffect(() => {
        if (!values.userId) return;

        dataProvider
            .getOne('users', { id: values.userId })
            .then(({ data: user }) => {
                if (!user?.partnerId) return;

                const isBoxitPartner = user.partnerId === 1;

                // If customer's partner is Boxit (id=1), use customer's country
                if (isBoxitPartner && user?.countryId) {
                    form.change('countryId', user.countryId);
                    return;
                }

                // Otherwise, use partner's country
                return dataProvider
                    .getOne('partners', { id: user.partnerId })
                    .then(({ data: partner }) => {
                        if (partner?.countryId) {
                            form.change('countryId', partner.countryId);
                        }
                    });
            })
            .catch(err =>
                console.error('Error prefilling address country:', err)
            );
    }, [values.userId]);

    return null;
};

const AddressCreate = props => {
    const isAdmin = useIsAdmin(props?.permissions);

    return (
        <Create {...props}>
            <SimpleForm variant="outlined" redirect="show">
                <AddressCountryPrefill />

                <ReferenceInput
                    label="User"
                    source="userId"
                    reference="users"
                    resource="users"
                    validation={{ required: true }}
                    allowEmpty
                >
                    <AutocompleteInput
                        shouldRenderSuggestions={val => val.trim().length > 2}
                        optionText={user =>
                            user.name ? user.name : user.email
                        }
                    />
                </ReferenceInput>
                <TextInput source="name" label="Address Name" />
                <TextInput multiline source="line1" label="Line" />
                <PlaceAutoComplete source="area" />
                <ReferenceInput
                    label="City"
                    source="cityId"
                    reference="city"
                    resource="city"
                    allowEmpty
                >
                    <SelectInput optionText="name" />
                </ReferenceInput>

                {/* Country: auto-prefilled + locked after partner resolution */}
                <FormDataConsumer>
                    {({ formData }) => (
                        <ReferenceInput
                            label="Country"
                            source="countryId"
                            reference="country"
                            resource="country"
                        >
                            <SelectInput
                                optionText="name"
                                disabled={!isAdmin && !!formData.userId}
                            />
                        </ReferenceInput>
                    )}
                </FormDataConsumer>
            </SimpleForm>
        </Create>
    );
};

export default AddressCreate;
